export class Horse {
	id: string;
	name: string;
	breed: string;
	breed_number: string;
	color: string;
	sex: string;
	pony: boolean;
	height: string;
	date_of_birth: Date;
	birth_place: string;
	sire: string;
	dam: string;
	dam_sire: string;
	usef_number: string;
	ec_number: string;
	fei_id: string;
	passport_country: string;
	hidden: boolean;
	ushja_id: string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}
